const defaultSlider = {
  perView: 5,
  perSwipe: "|",
  autoplay: 0
};
const DEFAULT_NUMBER_DISPLAY_FORMAT = {
  thousandSeparator: ".",
  decimalSeparator: ","
};
var SOURCE_VIDEO = /* @__PURE__ */ ((SOURCE_VIDEO2) => {
  SOURCE_VIDEO2["SYSTEM"] = "SYSTEM";
  SOURCE_VIDEO2["YOUTUBE"] = "YOUTUBE";
  return SOURCE_VIDEO2;
})(SOURCE_VIDEO || {});
const CHAR_WIDTH_RATIOS = {
  a: 0.5439,
  b: 0.5615,
  c: 0.5234,
  d: 0.564,
  e: 0.5303,
  f: 0.3477,
  g: 0.5615,
  h: 0.5508,
  i: 0.2432,
  j: 0.2393,
  k: 0.5068,
  l: 0.2432,
  m: 0.877,
  n: 0.5522,
  o: 0.5703,
  p: 0.5615,
  q: 0.5684,
  r: 0.3389,
  s: 0.5161,
  t: 0.3271,
  u: 0.5513,
  v: 0.4844,
  w: 0.7515,
  x: 0.4961,
  y: 0.4731,
  z: 0.4961,
  A: 0.6523,
  B: 0.623,
  C: 0.6509,
  D: 0.6563,
  E: 0.5684,
  F: 0.5527,
  G: 0.6812,
  H: 0.7134,
  I: 0.272,
  J: 0.5518,
  K: 0.6274,
  L: 0.5386,
  M: 0.873,
  N: 0.7134,
  O: 0.688,
  P: 0.6309,
  Q: 0.688,
  R: 0.6162,
  S: 0.5938,
  T: 0.5967,
  U: 0.6484,
  V: 0.6367,
  W: 0.8872,
  X: 0.627,
  Y: 0.6006,
  Z: 0.5991
};
const DEFAULT_CHAR_WIDTH_RATIO = 0.5527;
const REGION_NAME = {
  SIMILAR_PRODUCTS_POPUP: "similarProductsPopup"
};
const REGION_CONTENT_MAPPING = {
  [REGION_NAME.SIMILAR_PRODUCTS_POPUP]: "addToCart"
};

export { CHAR_WIDTH_RATIOS, DEFAULT_CHAR_WIDTH_RATIO, DEFAULT_NUMBER_DISPLAY_FORMAT, REGION_CONTENT_MAPPING, REGION_NAME, SOURCE_VIDEO, defaultSlider };
